import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "home-page" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "home-page__header" }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h3", { class: "home-page__header_title" }, " bo-reports-app-ui ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}